export enum Languages {
  EN_US = 'en-US',
  UK_UA = 'uk-UA',
}

export const availableLanguages = [
  { value: Languages.EN_US, label: 'English' },
  { value: Languages.UK_UA, label: 'Українська' },
];
